<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="70px">
					<el-form-item label="所属团队" label-width="70px" v-if="roleId==2">
						<el-select v-model="queryParams.teamId" style="width: 100%;" placeholder="请选择团队"  :clearable="true">
							<el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="设备" label-width="50px">
						<el-select v-model="queryParams.deviceId" clearable filterable remote reserve-keyword placeholder="请选择设备" :remote-method="queryDeviceList"
							:loading="deviceLoading" @focus="deviceSelectFocus" :clearable="true" @change="deviceChange">
							<el-option v-for="item in deviceList" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="变量" label-width="50px">
						<el-select v-model="queryParams.variableId" filterable remote reserve-keyword placeholder="请选择变量" :remote-method="queryTemplateVariableList"
							:loading="templateVariableLoading" @focus="templateVariableSelectFocus" :clearable="true" @change="templateVariableChange">
							<el-option v-for="item in templateVariableList" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="报警状态">
						<el-select v-model="queryParams.status" placeholder="请选择报警状态">
							<el-option label="全部" value=""></el-option>
							<el-option label="报警" :value="2"></el-option>
							<el-option label="正常" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="报警日期">
						<el-date-picker v-model="queryParams.createDates" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始时间"
							end-placeholder="结束时间" value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column prop="deviceTitle" label="设备名称"></el-table-column>
					<el-table-column prop="triggerTitle" label="触发器名称">
						<template slot-scope="scope">
							<div v-if="scope.row.status==1" style="color:#67C23A">
								{{scope.row.triggerTitle}}
							</div>
							<div v-else style="color:#F56C6C">
								{{scope.row.triggerTitle}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="triggerType" label="触发器类型" width="100px">
						<template slot-scope="scope">
							{{scope.row.triggerType |formatTriggerType}}
						</template>
					</el-table-column>
					<el-table-column prop="variableTitle" label="变量"></el-table-column>
					<el-table-column prop="variableValue" label="当前值"  width="100px"></el-table-column>
					<el-table-column prop="triggerCondition" label="触发条件"></el-table-column>
					<el-table-column prop="status" label="报警状态" width="80px">
						<template slot-scope="scope">
							{{scope.row.status | formatAlarmState}}
						</template>
					</el-table-column>
					<el-table-column prop="alarmMessage" label="报警内容"></el-table-column>
					<el-table-column prop="createTime" label="报警时间"></el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';

	export default {
		extends: BaseSearch,
		props: ['device'],
		data() {
			return {
				url: 'alarm/log',
				name: '报警记录',
				rules: {},
				deviceList: [],
				deviceLoading: false,
				queryDeviceParams: {
					currentPage: 1,
					pageSize: 10,
					defaultSort: {
						order: 'desc',
						prop: 'id'
					}
				},
				queryTemplateVariableParams: {
					currentPage: 1,
					pageSize: 10,
					defaultSort: {}
				},
				dialogTemplateVariableVisible: false,
				templateVariableList: [],
				templateVariableLoading: false,
				institutionList:[],
				teamList:[],
				roleId:null
			};
		},
		filters: {
			formatStatus(status) {
				if (status == 0) {
					return "未处理"
				} else if (status == 1) {
					return "已处理"
				}
			},
			formatAlarmState(alarmState){
				if(alarmState==1){
					return '正常'
				}else{
					return '报警'
				}
			},
			formatTriggerType(triggerType){
				if(triggerType=='device'){
					return '设备'
				}
			}
		},
		methods: {
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {};
				}
			},
			beforeUpdate() {},
			deviceSelectFocus() {
				this.queryDeviceList()
			},
			deviceChange() {
				if(this.queryParams.deviceId){
					let device = this.deviceList.find((item) => item.id === this.queryParams.deviceId);
					this.queryParams.templateId = device.templateId
				}else{
					this.queryParams.templateId = null
				}
				this.queryParams.variableId = null
				
			},
			templateVariableChange() {
				this.$forceUpdate(); // 强制重新渲染当前组件
			},
			queryDeviceList(query) {
				let that = this;
				this.deviceLoading = true;
				this.queryDeviceParams.title = query;
				this.$http({
					method: 'POST',
					url: 'devices/query',
					data: this.queryDeviceParams,
				}).then(function(res) {
					that.deviceList = res.data.data;
					that.deviceLoading = false
				})
			},
			templateVariableSelectFocus() {
				this.queryTemplateVariableList()
			},
			queryTemplateVariableList(query) {
				let that = this;
				this.queryTemplateVariableParams.title = query;
				if (this.queryParams.templateId) {
					this.templateVariableLoading = true;
					this.queryTemplateVariableParams.templateId = this.queryParams.templateId;
					this.$http({
						method: 'POST',
						url: 'template/variable/query',
						data: this.queryTemplateVariableParams,
					}).then(function(res) {
						that.templateVariableList = res.data.data;
						that.templateVariableLoading = false
					})
				} else {
					that.templateVariableList = []
					this.queryParams.variableId = null
				}
			},
			queryTeamList() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'team/query',
					data: {
						currentPage: 1,
						pageSize: 100,
						defaultSort: {
							order: 'desc',
							prop: 'id'
						}
					},
				}).then(function(res) {
					that.teamList = res.data.data;
				})
			}
		},
		mounted: function() {
			this.institutionId = sessionStorage.getItem('_institutionId');
			this.roleId = sessionStorage.getItem('_roleId');
			if(this.device){
				this.deviceList=[{
					id:this.device.id,
					title:this.device.title
				}]
				this.queryParams.deviceId=this.device.id
				this.queryParams.templateId=this.device.templateId
			}
			if(this.roleId==2){
				this.queryTeamList()
			}
			if (this.$route.query.teamId) {
				this.queryParams.teamId=this.$route.query.teamId;
			}
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/log/alarmLog.vue